module.exports = __webpack_public_path__ + "static/img/arrange.ec3baca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrange.png
// module id = IdSR
// module chunks = 1